var _Int32_value;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Exception from '../../Exceptions/Exception';
import { ensureInt } from "./ensureInt";
import Result from '../../Result/Result';
export default class Int32 extends Number {
    constructor(value) {
        super(value);
        _Int32_value.set(this, void 0);
        ensureInt(value, Int32.minValue, Int32.maxValue);
        __classPrivateFieldSet(this, _Int32_value, value, "f");
    }
    [(_Int32_value = new WeakMap(), Symbol.toPrimitive)]() {
        return this.valueOf();
    }
    valueOf() {
        return __classPrivateFieldGet(this, _Int32_value, "f").valueOf() & 0xFFFFFFFF;
    }
    static parse(value) {
        const int = parseInt(value);
        return new Int32(int);
    }
    static tryParse(value) {
        const int = parseInt(value);
        try {
            ensureInt(int, Int32.minValue, Int32.maxValue);
            return Result.ok(new Int32(int));
        }
        catch (ex) {
            if (ex instanceof Exception) {
                return Result.fail(ex.message);
            }
            else if (ex instanceof Error) {
                return Result.fail(ex.message);
            }
            else {
                return Result.fail(`${ex}`);
            }
        }
    }
}
/** The largest number that can be represented. Equal to 2,147,483,647. */
Int32.maxValue = 2147483647;
/** The lowest number that can be represented. Equal to -2,147,483,648. */
Int32.minValue = -2147483648;
